<mat-sidenav-container>
  <!-- Zijmenu -->
  <mat-sidenav
    #sideNav
    fixedInViewport
    [attr.role]="browserUtils.isHandset() ? 'dialog' : 'navigation'"
    [mode]="browserUtils.isHandset() ? 'push' : 'side'"
    [opened]="browserUtils.isHandset() === false"
  >
    <div class="sidenav-container">
      <div class="sidenav-title">
        <img src="assets/dv_icon.svg" alt="Dura Vermeer" class="logo" />
        <h4>Integration Portal</h4>
      </div>
      <mat-nav-list (click)="closeSideNavIfHandset(sideNav)">
        <a mat-list-item [routerLink]="['/home']" [routerLinkActive]="'is-active'">
          <span class="nav-link-content">
            <mat-icon fontSet="material-icons-outlined">home</mat-icon>
            <span class="nav-link-text">{{ t.home }}</span>
          </span>
        </a>
        <a mat-list-item [routerLink]="['/licenties']" [routerLinkActive]="'is-active'">
          <span class="nav-link-content">
            <mat-icon fontSet="material-icons-outlined">key</mat-icon>
            <span class="nav-link-text">{{ t.licenties }}</span>
          </span>
        </a>
      </mat-nav-list>
    </div>
  </mat-sidenav>

  <!-- Hoofdsectie -->
  <mat-sidenav-content>
    <mat-toolbar>
      <div class="menu-button-container">
        @if (browserUtils.isHandset()) {
          <button matIconButton aria-label="schakel zijmenu" (click)="sideNav.toggle()">
            <mat-icon>menu</mat-icon>
          </button>
        }
      </div>
      <app-user-avatar></app-user-avatar>
    </mat-toolbar>

    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
